import { render, staticRenderFns } from "./QnaList.vue?vue&type=template&id=ea470c2a&"
import script from "./QnaList.vue?vue&type=script&lang=js&"
export * from "./QnaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports